interface MaterialStatsProps {
  tongVatTu: number;
  htxCapUng: number;
  tuMua: number;
  sapHet: number;
  thieu: number;
}

export function MaterialStats({
  tongVatTu,
  htxCapUng,
  tuMua,
  sapHet,
  thieu,
}: MaterialStatsProps) {
  const items = [
    { label: 'Tổng vật tư', value: `${tongVatTu} mục`, icon: 'ri-box-3-line', color: 'text-agrida-700', bg: 'bg-agrida-50' },
    { label: 'Vật tư HTX cấp/ứng', value: `${htxCapUng} mục`, icon: 'ri-truck-line', color: 'text-sky-700', bg: 'bg-sky-50' },
    { label: 'Vật tư tự mua', value: `${tuMua} mục`, icon: 'ri-shopping-cart-line', color: 'text-amber-700', bg: 'bg-amber-50' },
    { label: 'Vật tư sắp hết', value: `${sapHet} mục`, icon: 'ri-timer-flash-line', color: 'text-amber-700', bg: 'bg-amber-50' },
    { label: 'Vật tư thiếu', value: `${thieu} mục`, icon: 'ri-error-warning-line', color: 'text-red-700', bg: 'bg-red-50' },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2 mb-4">
      {items.map((item) => (
        <div key={item.label} className={`${item.bg} rounded-2xl px-3.5 py-3 flex items-center gap-2.5`}>
          <span className={`w-7 h-7 flex items-center justify-center rounded-xl bg-white/70 shrink-0 ${item.color}`}>
            <i className={`${item.icon} text-xs`} />
          </span>
          <div className="min-w-0">
            <p className="text-[11px] text-slate-600 truncate">{item.label}</p>
            <p className={`text-base font-bold ${item.color}`}>{item.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
}